import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, MenuController, ToastController, LoadingController, Events } from 'ionic-angular';
import { ServiceSidemenuProvider } from '../../providers/service-sidemenu/service-sidemenu';
import { B01DashboardPage } from '../b01-dashboard/b01-dashboard';
import { ServiceApiProvider } from '../../providers/service-api/service-api';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { B03CardManagementPage } from '../b03-card-management/b03-card-management';

/**
 * Generated class for the A01LoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@IonicPage()
@Component({
  selector: 'page-a01-login',
  templateUrl: 'a01-login.html',
})
export class A01LoginPage {
  private todo : FormGroup;

  loading: any;
  Status: any;
  loginData = { USER_NAME:'', PASSWORD:'' };
  userBranchId: any = null;
  branchName: any = null;
  userId: any = null;
  userName: any = null;
  userActive: any = null;
  userGrpId: any = null;
  userGrpName: any = null;
  userCorpId: any = null;
  userCorpName: any = null;
  userAccessId: any = [];
  numberData:number = 0;

  public errorMessage: any = "";

  public pages: Array<{title: string, component: any, class:any, icon:string}>;

  constructor(public navCtrl: NavController, public navParams: NavParams, 
              public menuCtrl:MenuController,public sidemenu:ServiceSidemenuProvider, 
              public serviceapi: ServiceApiProvider, private formBuilder: FormBuilder,
              private toastCtrl: ToastController, public loadingCtrl: LoadingController,
              public events: Events ) {

    this.todo = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    });


      /* let sortby= "USER_ID";
      let sorttype= "DESC";

      let searchval = "No";
      let searchby = "No";
      let searchtbl = "No";
      
     
      let tbl = ["USER","USER_GRP"];
      let column = ["USER_ID","GRP_NAME"];
      let value = ["1","Admin"];
      
      let tblkey = ["GRP_ID","CORP_ID"];
      let fktbl = ["USER_GRP","CORPORATE"];
      let fkkey = ["GRP_ID","CORP_ID"];
    
      //mydata.push(this.serviceapi.format("USER_ID","DESC"));
      //mydata.push(this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey));
      //mydata.push(this.serviceapi.search("Admin",searchby,searchtbl));
      let jsonsort = this.serviceapi.sort(sortby,sorttype);
      let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
      //let jsonsearch = this.serviceapi.search(searchval,searchby,searchtbl);
      let mydata = Object.assign(jsonsort,jsonitem);
      let json_data = this.serviceapi.json_readdata(mydata,"1");
      this.serviceapi.readdata(json_data,"USER","1").then((result) => {
         
         this.Status = result["Message"];
         console.log(result["Records"]);
       }, (err) => {
     
       }); */

    if(sessionStorage.getItem("token") != null){          //if have login memory

      this.userId = sessionStorage.getItem('userid');     //user ID

      let tbl = ["USER"];
      let column = ["USER_ID"];
      let value = [this.userId];
      
      let tblkey = ["GRP_ID","CORP_ID"];
      let fktbl = ["USER_GRP","CORPORATE"];
      let fkkey = ["GRP_ID","CORP_ID"];


      let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
      let mydata = Object.assign(jsonitem);
      let json_data = this.serviceapi.json_readdata(mydata,"1");
      this.showLoader();

      this.loginAttempt(json_data);
    }

         
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad A01LoginPage');
  }

  ionViewWillEnter() {
    // Disable the split plane in this page
       this.sidemenu.setSplitPane(false);
       this.menuCtrl.swipeEnable(false);
     }
   
  ionViewDidLeave() {
// Enable it again when leaving the page
    this.sidemenu.setSplitPane(true);
    this.menuCtrl.swipeEnable(true);
  }

  login()
  {
    console.log(this.loginData);
    this.showLoader();
/*     this.userAccessId = ['1','2','3','4','5','6','7','8','9'];
    this.userName = 'asdaad';
    this.events.publish('user:created', this.userName, this.userAccessId, Date.now());
     this.navCtrl.setRoot(B01DashboardPage);  */

    /* this.serviceapi.validatedata("USER", this.loginData).then((result) => {
        
      this.Status = result["Message"];
      console.log(result["Records"]);
      if (this.Status == "1"){
        this.loading.dismiss();
        this.navCtrl.setRoot(B01DashboardPage);

        //check user active flag
        //save user authority
      }
      else {
        this.loading.dismiss();
        this.presentToast("Login Failed. Username or password is incorrect.");
      }
    }, (err) => {
      this.loading.dismiss();
      this.presentToast(err);
    }); */


    let tbl = ["USER","USER"];
    let column = ["USER_NAME","PASSWORD"];
    let value = [this.loginData.USER_NAME,this.loginData.PASSWORD];
    
    let tblkey = ["GRP_ID","CORP_ID"];
    let fktbl = ["USER_GRP","CORPORATE"];
    let fkkey = ["GRP_ID","CORP_ID"]; 
/*     let tblkey = ["No"];
    let fktbl = ["No"];
    let fkkey = ["No"]; */

    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
    let mydata = Object.assign(jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
    console.log(json_data);
    this.loginAttempt(json_data);
  }

  cancel(){
    this.loginData.USER_NAME = ""; 
    this.loginData.PASSWORD = ""; 
  }

  showLoader(){
//    clearTimeout();                               //clear previouse timeout

    this.loading = this.loadingCtrl.create({
        content: 'Authenticating...',
        duration: 5000
//        dismissOnPageChange: true,
    });

    this.loading.present();

/*     setTimeout(() => {
      if(this.loading.instance){                  //check if loading still showing
        this.errorMessage = "Loading timeout";
        this.loading.dismiss();
      }

    }, 5000); */
  }

  presentToast(msg) {
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'bottom',
      dismissOnPageChange: true
    });

    toast.present();
  }

  loginAttempt(json_data){

    this.serviceapi.readdata(json_data,"USER","1","1").then((result) => {
        
      this.Status = result["Message"];
      console.log(result["Message"]);
      
      if (this.Status == "1"){
        this.loading.dismiss();
        let Records = result["Records"];
        this.userId = Records[0]["USER_ID"];
        this.userName = Records[0]["USER_NAME"];
        this.userBranchId = Records[0]["BRANCH_ID"];
        this.userActive = Records[0]["USER_ACTIVE"];
        this.userGrpId = Records[0]["GRP_ID"];
        this.userGrpName = Records[0]["GRP_NAME"];
        this.userCorpId = Records[0]["CORP_ID"];
        this.userCorpName = Records[0]["CORP_NAME"];
        
        if (this.userActive == "YES") {
            
            sessionStorage.setItem('token', 'mobil');                         //store for limited time
            sessionStorage.setItem('userid', this.userId);
            sessionStorage.setItem('username', this.userName);
            sessionStorage.setItem('userbranchid', this.userBranchId);
            sessionStorage.setItem('useractive', this.userActive);
            sessionStorage.setItem('usergroupid', this.userGrpId);
            sessionStorage.setItem('usergroupname', this.userGrpName);
            sessionStorage.setItem('usercorpid', this.userCorpId);
            sessionStorage.setItem('usercorpname', this.userCorpName);

            let tbl = ["USER_GRP_ACCESS"];
            let column = ["GRP_ID"];
            let value = [this.userGrpId];
            
            let tblkey = ["ACCESS_ID"];
            let fktbl = ["USER_ACCESS"];
            let fkkey = ["ACCESS_ID"];

            let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
            let mydata = Object.assign(jsonitem);
            let json_data = this.serviceapi.json_readdata(mydata,"1");

            //read access level
            this.serviceapi.readdata(json_data,"USER_GRP_ACCESS","1","1").then((result) => {
        
              this.Status = result["Message"];
              let Records = result["Records"];
              
              if (this.Status == "1"){
                  let rxData = result["RXData"];
                  this.numberData = rxData;
              }
              else {
                this.numberData = 0;
              }

              for (let i=0; i<=(this.numberData-1); i++)       //store ACCESS_ID
              {
                  this.userAccessId.push(Records[i]["ACCESS_ID"]);
              } 
              console.log(this.userAccessId);

              sessionStorage.setItem('useraccessid', this.userAccessId);
              this.events.publish('user:created', this.userName, this.userAccessId, Date.now(), this.userGrpId);  //create GRP_ID in events, for filter side menu item

/*               //Different first page based on group ID
              if ((this.userGrpId == "6") || (this.userGrpId == "7") || (this.userGrpId == "8"))  //corporate go card
                this.navCtrl.setRoot(B03CardManagementPage);
              else                                                                                //system admin & branch go dashboard
                this.navCtrl.setRoot(B01DashboardPage); */

            }, (err) => {
              this.errorMessage = "Login Error. Please try again.";
              this.loading.dismiss();
            });

            
        }
        else {
            this.errorMessage = "Login Failed. This username is blocked.";
        }

      }
      else {
        this.errorMessage = "Login Failed. Username or password is incorrect.";
        this.loading.dismiss();
      }
    }, (err) => {
        this.errorMessage = "Login Error. Please try again.";
        this.loading.dismiss();
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/a01-login/a01-login.ts